<template>
    <modal class="modal" :show="modal_show" body-classes="card-body" modal-classes="modal-dialog-centered modal-sm"
        footer-classes="card-footer" header-classes="card-header" v-on:close="onClose()">

        <template v-slot:header>
            <h2>{{ $t(this.$route.name + '.moduleModalTitle') }}</h2>
        </template>
        <div id="card-body">
            <!-- Module name -->
            <div class="row">
                <div class="col">
                    <span>{{ $t($route.name + '.moduleName') }}</span>
                    <Popper arrow class="light" :content="$t($route.name + '.moduleNameInfoPopover')">
                        <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <base-input formClasses="input-group-alternative" type="text"
                            :placeholder="$t($route.name + '.moduleNamePlaceholder')" v-model="v$.inner_data.name.$model"
                            :error="errorsArrayToSingleString(v$.inner_data.name.$errors)">
                        </base-input>
                    </div>
                </div>
            </div>
            <!-- End of module name -->

            <!-- Module plot -->
            <div class="row">
                <div class="col">
                    <span>{{ $t($route.name + '.modulePlot') }}</span>
                    <Popper arrow class="light" :content="$t($route.name + '.modulePlotInfoPopover')">
                        <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
                </div>
            </div>
            <div class="row">
                <div v-if="inner_data" class="col">
                    <select :v-model="plot_selected" @change="onPlotSelect($event)">
                        <option v-for="plot in plot_list" :key="plot" :value="plot.id" :selected="plot.name == plot_selected">
                            <span v-if="plot.name != 'UnallocatedModulesPlot'">{{ plot.name }}</span>
                            <span v-else>{{ $t($route.name + '.moduleNotPlotAllocated') }}</span>
                        </option>
                    </select>
                </div>
            </div>
            <!-- End of plot select -->

            <!-- Module enable -->
            <div class="row">
                <div class="col">
                    <span>{{ $t($route.name + '.moduleEnable') }}</span>
                    <Popper arrow class="light" :content="$t($route.name + '.moduleEnableInfoPopover')">
                        <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
                </div>
            </div>
            <div class="row">
                <div v-if="inner_data" class="col">
                    <base-switch v-model="inner_data.enabled" :value="inner_data.enabled">
                    </base-switch>
                </div>
            </div>
            <!-- End of module enable -->

            <!-- Module installation date -->
            <div class="row">
                <div class="col">
                    <span>{{ $t($route.name + '.moduleInstallationDate') }}</span>
                    <Popper arrow class="light" :content="$t($route.name + '.moduleInstallationDateInfoPopover')">
                        <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
                </div>
            </div>
            <div class="row">
                <div v-if="inner_data" class="col">
                    <div class="input-group">
                        <v-date-picker class="inline-block h-full" v-model="inner_data.installation_date"
                            :locale="getUserLanguage()">
                            <template v-slot="{ inputValue, togglePopover }">
                                <div class="flex items-center">
                                    <button @click="togglePopover()">
                                        <i class="ni ni-calendar-grid-58"></i>
                                    </button>
                                    <input :value="inputValue"
                                        class="bg-white text-gray-700 w-full py-1 px-2 appearance-none border rounded-r focus:outline-none focus:border-blue-500"
                                        readonly />
                                </div>
                            </template>
                        </v-date-picker>
                    </div>
                </div>
            </div>
            <!-- End of module instalation date -->
        </div>


        <template v-slot:footer>
            <div class="row">
                <div class="col">
                    <base-button type="primary" class="btn btn-block btn-success" style="width:100%"
                        v-on:click="handleUpdate()">
                        {{ $t(this.$route.name + '.update') }}
                    </base-button>
                </div>
                <div class="col">
                    <base-button type="primary" class="btn btn-block btn-outline-default" v-on:click="onRestoreButton()">
                        {{ $t(this.$route.name + '.restoreModule') }}
                    </base-button>
                </div>
                <div class="col">
                    <base-button type="primary" class="btn btn-block btn-warning" v-on:click="onClose()">
                        {{ $t(this.$route.name + '.cancelButton') }}
                    </base-button>
                </div>
            </div>
        </template>

    </modal>
</template>
<script>
import ModuleService from '@/services/module.service'
import ModuleModel from './module.model'

import useVuelidate from '@vuelidate/core'
import { required, minLength, helpers } from '@vuelidate/validators'

export default {
    name: "module-modal",
    setup() {
        return { v$: useVuelidate() }
    },
    props: {
        modal_show: {
            type: Boolean,
            default: false,
        },
        module_data: null,
        plot_list: [],
        module_list: [],
        on_data_submit: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            show: {
                type: Boolean,
                default: false,
            },
            inner_data: JSON.parse(JSON.stringify(ModuleModel.empty_module_model)),
            original_inner_data: JSON.parse(JSON.stringify(ModuleModel.empty_module_model)),
            plot_selected: null,
        };
    },
    created() {
        
        this.onShow();
    },
    watch: {
        modal_show: function () {
            if (this.modal_show) {
                this.plot_selected = this.getPlotNameById(this.inner_data.plot_id);
            }
        },
        module_data: function () {
            this.onShow();
        }
    },
    methods: {
        onShow() {
            this.inner_data = JSON.parse(JSON.stringify(this.module_data));

            if (this.inner_data != "" && this.inner_data.installation_date == null) {
                const date = new Date();
                this.inner_data.installation_date = date.toISOString();
            }

            this.original_inner_data = JSON.parse(JSON.stringify(this.inner_data));

            this.plot_selected = this.getPlotNameById(this.inner_data.plot_id);            

        },

        onClose: function () {
            localStorage.setItem('moduleId', null)
            this.$emit('update:modal_show', false);

        },

        onRestoreButton: function () {
            this.inner_data = JSON.parse(JSON.stringify(this.original_inner_data));
        },

        getItemByParamName: function (param_name) {
            var item = this.params[param_name];
            if (typeof item === 'object') {
                return item;
            }
        },

        handleUpdate: function () {

            ModuleService.updateModule(this.inner_data).then(
                () => {

                    // Reload the page to refresh data
                    this.$emit('update:on_data_submit', true);
                    this.onClose();


                }
            )
        },

        errorsArrayToSingleString(array) {
            var str = "";
            if (array.length == 0) return
            array.forEach(item => str += item.$message + '\n')
            return str;
        },

        checkIfPlotNameAlreadyExists(name) {
            // return true if doesn't exists and false if it does
            return this.module_list.filter(mod => mod.name === name).length == 0;
        },

        onPlotSelect(event) {
            const plot_id = event.target.value;
            const plot = this.plot_list.find(plot => plot.id == plot_id);

            this.inner_data.plot_id = plot.id;
            this.inner_data.plot_name = plot.name;

        },

        getPlotNameById(id) {
            const plot = this.plot_list.find(plot => plot.id == id);
            if (plot) {
                return plot.name;
            } else {
                return null;
            }
        },

        getUserLanguage() {
            return this.$i18n.locale;
        }
    },
    validations() {
        return {
            inner_data: {
                name: {
                    required_custom: helpers.withMessage(this.$t(this.$route.name + '.errorFieldRequired'), required),
                    min: helpers.withMessage(this.$t(this.$route.name + '.errorInvalidLength', { length: '6' }), minLength(6)),
                    valid_name: helpers.withMessage(this.$t(this.$route.name + '.errorNameAlreadyExists'), this.checkIfPlotNameAlreadyExists),
                },
            }
        }
    }
};
</script>
<style>
.modal {
    overflow: auto !important;
}
</style>
